/**
 * CSS
 */
import '../src/scss/main.scss';

/**
 * JS
 */
import '../src/js/lib/slick.min.js';
import '../src/js/lib/responsive-menus.js';
import '../src/js/main';
